import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@/shared/config/router/types';
import { getDecodedStartappQuery } from '@/shared/helpers';
import {
  getCloudStorageValue,
  setCloudStorageValue,
} from '@/shared/helpers/cloud-storage';

import { RETURN_PATHNAME_KEY, STREAK_PAGE_LAST_VIEWED_KEY } from '../constants';

export const useDaysStreakPageRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndRedirect = async () => {
      const today = new Date().toISOString().split('T')[0];
      const lastViewed = await getCloudStorageValue(STREAK_PAGE_LAST_VIEWED_KEY);

      if (lastViewed !== today) {
        await setCloudStorageValue(STREAK_PAGE_LAST_VIEWED_KEY, today);

        const startAppArgs = getDecodedStartappQuery();

        if (location.pathname !== ROUTE_PATHS.DAYS_STREAK) {
          navigate(ROUTE_PATHS.DAYS_STREAK, {
            replace: true,
            state: {
              [RETURN_PATHNAME_KEY]:
                startAppArgs?.path ??
                `${location.pathname}${location.search}${location.hash}`,
            },
          });
        }
      }
    };

    void checkAndRedirect();
  }, [navigate, location]);
};
